var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.visible,
                title: _vm.$t("Invoice.invoice_ModifyInvoiceInformation"),
                width: "400px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  _vm.visible = $event
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  staticStyle: { "flex-direction": "row" },
                  attrs: { "label-position": "left", "label-width": "100px" }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Invoice.invoice_invoiceType") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "175px" },
                          attrs: { no: "1" },
                          on: { change: _vm.invoiceTypeChange },
                          model: {
                            value: _vm.invoice.invoiceType,
                            callback: function($$v) {
                              _vm.$set(_vm.invoice, "invoiceType", $$v)
                            },
                            expression: "invoice.invoiceType"
                          }
                        },
                        _vm._l(
                          _vm.isFei
                            ? _vm.InvoiceConstant.INVOICE_TYPES_FEI
                            : _vm.InvoiceConstant.INVOICE_TYPES,
                          function(item) {
                            return _c("el-option", {
                              key: item.code,
                              attrs: {
                                label:
                                  _vm.$store.getters.language === "zh"
                                    ? item.chineseName
                                    : item.englishName,
                                value: item.code
                              }
                            })
                          }
                        ),
                        1
                      )
                    ],
                    1
                  ),
                  _vm.invoice.invoiceType === 6 || _vm.invoice.invoiceType === 7
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Invoice.SpecificConstraintTypes")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "175px" },
                              model: {
                                value: _vm.invoice.specificConstraintType,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.invoice,
                                    "specificConstraintType",
                                    $$v
                                  )
                                },
                                expression: "invoice.specificConstraintType"
                              }
                            },
                            _vm._l(
                              _vm.InvoiceConstant.SPECIFIC_CONSTRAINT_TYPES,
                              function(item) {
                                return _c("el-option", {
                                  key: item.code,
                                  attrs: {
                                    label:
                                      _vm.$store.getters.language === "zh"
                                        ? item.chineseName
                                        : item.englishName,
                                    value: item.code
                                  }
                                })
                              }
                            ),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Invoice.invoice_makeType") } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { no: "3" },
                          model: {
                            value: _vm.invoice.makeType,
                            callback: function($$v) {
                              _vm.$set(_vm.invoice, "makeType", $$v)
                            },
                            expression: "invoice.makeType"
                          }
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: {
                                label: 0,
                                disabled:
                                  _vm.invoice.invoiceType === 6 ||
                                  _vm.invoice.invoiceType === 7
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("Invoice.invoice_makePaper"))
                              )
                            ]
                          ),
                          _c(
                            "el-radio",
                            {
                              attrs: {
                                label: 1,
                                disabled:
                                  _vm.invoice.invoiceType !== 2 &&
                                  _vm.invoice.invoiceType !== 3
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("Invoice.invoice_makeElectronic"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "4", type: "primary" },
                      on: { click: _vm.updateInvoiceTypeAndMakeType }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    { attrs: { no: "5" }, on: { click: _vm.closeHandler } },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }